<template>
  <div class="icon-container">
    <component :is="selectedIcon" v-if="type !== 'default'" />
  </div>
</template>

<script>
  import PlusIcon from '@/assets/icons/notifications/plus.svg';
  import DeclineIcon from '@/assets/icons/notifications/decline.svg';
  import ConfirmIcon from '@/assets/icons/notifications/confirm.svg';
  import FireIcon from '@/assets/icons/notifications/fire.svg';
  import TrashIcon from '@/assets/icons/notifications/trash.svg';
  import MehFaceIcon from '@/assets/icons/notifications/meh-face.svg';

  export default {
    name: 'NotificationIcon',
    components: {
      PlusIcon,
    },
    props: {
      type: {
        type: String,
        default: 'plus',
        validator: (type) =>
          ['plus', 'decline', 'confirm', 'fire', 'trash', 'meh_face'].includes(type),
      },
    },
    data() {
      return {
        iconByType: {
          plus: PlusIcon,
          decline: DeclineIcon,
          confirm: ConfirmIcon,
          fire: FireIcon,
          trash: TrashIcon,
          meh_face: MehFaceIcon,
        },
      };
    },
    computed: {
      selectedIcon() {
        return this.iconByType[this.type];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-container {
    width: 40px;
    height: 40px;
    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
